import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import Metatags from '@components/common/Metatags';
const PAGESSIZES = {
    base: 20,
    tier1: 25,
    tier2: 16,
};
const ListingPagination = (props) => {
    const { count, pageMetaTags, category } = useSelector((state) => state.search);
    /**
     * progress = last product tile index (1 based)
     * count = total number of items
     */
    const originalSize = (props.tier === 'tier1' && PAGESSIZES.tier1) || PAGESSIZES.tier2;
    const [pagination, setPagination] = useState([]);
    const start = useMemo(() => {
        return parseInt(props.start);
    }, [props.start]);
    const getAdditionalMeta = useCallback(() => {
        let list = [];
        if (category && category.url && pagination.length < 1) {
            list.push(React.createElement("link", { key: "canonical", href: `${location.origin + category.url}` }));
        }
        else {
            let currentIndex = pagination.findIndex((page) => page.current);
            let currentPage = pagination[currentIndex];
            if (currentPage) {
                list.push(React.createElement("link", { key: "canonical", href: currentPage.url }));
                let nextPage = pagination[currentIndex + 1];
                let prevPage = pagination[currentIndex - 1];
                if (!!prevPage) {
                    list.push(React.createElement("link", { key: "prev", rel: "prev", href: prevPage.url }));
                }
                if (!!nextPage) {
                    list.push(React.createElement("link", { key: "prev", rel: "next", href: nextPage.url }));
                }
            }
        }
        return list;
    }, [pagination]);
    useEffect(() => {
        let paging = [];
        if (!category || count > originalSize) {
            let variablePageSize = originalSize;
            let nextUntil = 0;
            do {
                let page = {
                    displayName: paging.length + 1,
                    first: nextUntil + 1,
                    last: nextUntil + variablePageSize,
                };
                variablePageSize = PAGESSIZES.base;
                page.url = `${location.origin + category.url}?start=${page.first}`;
                if (start == page.first)
                    page.current = true;
                paging.push(page);
                nextUntil = page.last;
            } while (nextUntil < count);
        }
        setPagination(paging);
    }, [count, start, category]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Metatags, { pageMetaTags: pageMetaTags, meta: category.meta, additionalMeta: getAdditionalMeta() }),
        pagination.length > 1 && (React.createElement("nav", { className: "d-none" },
            React.createElement("ul", null, pagination.map((page, i) => (React.createElement("li", { key: page.displayName }, page.current ? React.createElement("span", null, page.displayName) : React.createElement("a", { href: page.url }, page.displayName)))))))));
};
export default ListingPagination;
